import { XsrfOptions } from 'src/app/common/interceptors/xsrf.interceptor';
import { LogLevel } from 'src/app/common/util/log';

export const basePath: string = 'https://webrptanalysisservicedtokbb.azurewebsites.net/api/v1';
export const assetPath: string = 'https://analysisservice-dev.fe.union-investment.de/export';

export const loglevel: LogLevel = LogLevel.TRACE;

export const authInterceptorIgnoredUrls: string[] = [];

export const xsrfInterceptorIgnoredUrls: string[] = [];

export const xsrfOptions: XsrfOptions = {
  cookieName: 'XSRF-TOKEN-FONDSUEBERSICHT',
  headerName: 'X-XSRF-TOKEN-FONDSUEBERSICHT',
};

export const apimApiVersion: string = 'beta-1.0.0';

export const logging = {
  connectionString:
    'InstrumentationKey=c239a6ab-bd01-466b-881a-d91745512ade;IngestionEndpoint=https://westeurope-4.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=f7ee889c-3719-4d8a-8c32-ad80801aa288',
};